import MobileMenuSideBar from './MobileMenuSideBar';
import DesktopMenuSideBar from './DesktopMenuSideBar';
import SearchInput from './SearchInput';

export default {
  MobileMenuSideBar,
  DesktopMenuSideBar,
  SearchInput,
};
